import { type InsuranceCorporateIdentity } from "../types";

export function ConcordiaLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M260 297.959L329.935 364L378 315.182L310.042 251L260.494 297.836L260 297.959Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M180.845 202.185L168.562 170.887C168.241 169.964 167.994 169.016 167.825 168.053C167.825 164.603 168.562 162.015 171.387 162.015C176.177 162.015 177.406 166.821 178.266 167.807C185.946 179.476 191.017 192.676 193.128 206.498C193.912 212.961 192.667 219.508 189.566 225.228C188.979 226.325 188.683 227.556 188.706 228.801C188.706 230.773 189.935 230.649 191.409 232.621L200.007 241L250 193.437L208.114 153.513C193.128 139.096 192.023 135.4 175.932 131.333C170.279 130.622 164.543 131.052 159.058 132.596C153.574 134.141 148.452 136.77 143.995 140.328C136.968 147.143 129.129 153.061 120.657 157.949C118.937 158.565 117.463 159.304 117.095 161.276C116.827 162.85 117.132 164.468 117.955 165.835C118.814 167.807 119.92 168.3 121.271 169.901L172.615 219.19L180.845 208.1C181.31 207.317 181.556 206.423 181.556 205.512C181.556 204.601 181.31 203.707 180.845 202.925"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M329.671 201.721L341.976 170.352C342.298 169.427 342.545 168.477 342.715 167.512C342.715 164.054 341.976 161.46 339.146 161.46C334.347 161.46 333.117 166.277 332.255 167.265C324.571 178.966 319.493 192.193 317.366 206.044C316.597 212.521 317.844 219.078 320.934 224.816C321.522 225.916 321.819 227.149 321.796 228.397C321.796 230.373 320.565 230.25 319.088 232.226L179.915 364L135 313.859L302.353 153.309C317.366 138.489 318.35 135.525 334.47 131.45C340.083 130.627 345.804 130.935 351.297 132.356C356.79 133.776 361.946 136.281 366.464 139.724C373.805 146.408 381.803 152.325 390.337 157.385C392.059 158.126 393.536 158.743 393.905 160.719C394.174 162.297 393.868 163.919 393.044 165.289C392.182 167.265 391.075 167.759 389.721 169.364L338.285 218.764L329.671 206.785C329.205 206.001 328.959 205.104 328.959 204.191C328.959 203.278 329.205 202.382 329.671 201.598"
        fill="white"
      />
      <path
        d="M255.068 460H252.968C149.347 431.6 86.6056 363.685 85 278.484V80.9149H92.0398C92.9044 80.9149 174.048 74 253.956 74H255.809C336.088 74 418.096 80.9149 418.96 80.9149H426V277.743C423.406 361.216 360.542 429.006 257.908 459.383L255.068 460ZM100.438 95.1152V277.743C101.92 355.165 159.598 416.905 254.944 443.824C349.673 415.177 407.474 353.066 409.821 277.496V95.1152C388.331 93.5099 321.143 88.8177 255.068 88.8177H253.833C188.251 88.8177 121.805 93.5099 100.315 95.1152"
        fill="white"
      />
    </svg>
  );
}

export const Concordia: InsuranceCorporateIdentity = {
  id: "concordia",
  name: "Concordia",
  logo: ConcordiaLogo,
  backgroundColor: "#004B96",
  textColor: "#FFFFFF",
  wildcard: "concordia",
  type: "private",
};
